import { combineReducers } from "redux";
import authReducer from "./authReducer";
import errorReducer from "./errorReducer";
import world from "./world";
export default combineReducers({
  world : world ,
  auth: authReducer,
  errors: errorReducer
});